module.exports = __webpack_public_path__ + "242e9fc.woff2";